module.exports = __webpack_public_path__ + "static/HowToPlay-c67f756b488859fa40d90100258ed3a7.png";